<template lang="pug">
.container
  template(v-if="getLanguage == 'mn'")
    mnContent
  template(v-else)
    enContent
  .btn-read-more {{ $t('ui.read_more') }}
</template>

<script>
export default {
  components: {
    enContent: () => import("@/components/seo/_seo_en"),
    mnContent: () => import("@/components/seo/_seo_mn")
  },
  computed: {
    getLanguage() {
      return this.$store.getters.language
    }
  },
  mounted() {
    // btn-read-more
    $(".btn-read-more").click(function() {
      $('.seo').addClass('full-height');
      $('.btn-read-more').addClass('d-none');
    });
  }
}
</script>